<template>
  <div class="text-center">
    <div v-if="loading">
      <img :src="imagePreview" class="img-fluid mb-4" style="max-height: 400px;" />
      <p class="text-muted">{{ $t('AiHome.ocr.recognizing_hint') }}</p>
    </div>

    <div v-else-if="ocrText">
      <p class="text-success font-weight-bold mb-2">{{ $t('AiHome.ocr.recognition_complete') }}</p>
      <pre class="bg-light p-3 rounded text-left text-wrap">{{ ocrText }}</pre>
      <button @click="confirmText" class="btn btn-primary mt-4">{{ $t('AiHome.ocr.btn_confirm_text') }}</button>
    </div>

    <div v-else>
      <p class="text-danger py-3">{{ $t('AiHome.ocr.recognition_fail_hint') }}</p>
    </div>
  </div>
</template>

<script>
import api from '@/store/api'

export default {
  props: {
    croppedImage: Blob
  },
  data () {
    return {
      loading: true,
      ocrText: null,
      imagePreview: ''
    }
  },
  mounted () {
    this.getOCR()
  },
  methods: {
    confirmText () {
      this.$emit('next', this.ocrText)
    },
    getOCR () {
      if (!this.croppedImage) return

      this.imagePreview = URL.createObjectURL(this.croppedImage)

      const formData = new FormData()
      formData.append('file', this.croppedImage)

      api.post('/textract', formData, {
        headers: {
          ...api.defaults.headers.common,
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          let text = ''
          for (let value of response.data) {
            if (value.Text && value.BlockType === 'LINE') {
              text += value.Text + ' '
            }
          }
          this.ocrText = text
          this.$emit('next', text)
        })
        .catch((err) => {
          console.error('OCR API 錯誤:', err)
          this.ocrText = null
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  beforeDestroy () {
    URL.revokeObjectURL(this.imagePreview)
  }
}
</script>
